import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

const Considerapp = () => {
  return (
    <div className="consider_usa p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={5} xxl={5}>
            <div className="consider_content">
              <h2>When to Consider Our Flutter App Development Services</h2>
              <p>
                Whether you’re starting from scratch or upgrading, we ensure
                smooth and customized solutions for your Flutter app development
                needs.Here’s when you should consider signing up for our Flutter
                application development services:
              </p>
              <Link
                to="/contact"
                className="border_btn dark_btn"
                aria-label="TekRevol Contact"
              >
                Let's Build Your Flutter App
              </Link>
            </div>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="offset-xl-1">
            <div className="consider-box">
              <h6>Launching a New App</h6>
              <p>
                If you're introducing something new, like your own app, we've
                got you covered. Our Flutter mobile app development services can
                infuse your vision with a personal touch, ensuring a memorable
                debut.
              </p>
            </div>
            <div className="consider-box">
              <h6>Revamping an Existing App</h6>
              <p>
                If it's time for a change, consider revamping your existing app
                with us. As a provider of the best Flutter development services,
                we can breathe new life into your existing app.
              </p>
            </div>
            <div className="consider-box">
              <h6>Adopting Cross-Platform Development</h6>
              <p>
                If you're ready to expand your app's reach, consider adopting
                cross-platform development with us. As a top-grade Flutter app
                development agency, we can help you broaden your app's reach.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Considerapp;
